import { Route } from '@angular/router'
import { Permissions } from '../../access/shared/authorization/permissions'
import { StatsLHRouting } from './stats-LH/stats-LH-routing'
import { ExportRouting } from './export/export.routing'
import { StatisticComponent } from './statistic.component'

export const StatisticRouting: Route = {
  path: 'statistic',
  children: [
    { path: '', redirectTo: 'stock', pathMatch: 'prefix' },
    {
      path: 'stock',
      component: StatisticComponent,
      data: {
        breadcrumb: 'Etat des stocks',
        stats: 'stock',
        searchByName: true,
        canExportCurrent: true,
        canExportCurrentAndCS: true,
        canExportAll: true,
        canCheckOkCab: false
      },
      children: [
        ExportRouting
      ]
    },
    {
      path: 'porteur',
      component: StatisticComponent,
      data: {
        breadcrumb: 'Rotation des stocks VTs',
        stats: 'porteur',
        searchByName: true,
        canExportCurrent: true,
        canExportCurrentAndCS: true,
        canExportAll: true,
        canCheckOkCab: false
      },
      children: [
        ExportRouting
      ]
    },
    {
      path: 'rotation',
      component: StatisticComponent,
      data: {
        breadcrumb: 'Rotation des stocks de LP',
        stats: 'rotation',
        searchByName: false,
        canExportCurrent: true,
        canExportCurrentAndCS: false,
        canExportAll: false,
        canCheckOkCab: false
      },
      children: [
        ExportRouting
      ]
    },
    {
      path: '5-last-cleaning',
      component: StatisticComponent,
      data: {
        breadcrumb: '5 derniers lavages',
        stats: '5-last-cleaning',
        searchByName: true,
        canExportCurrent: true,
        canExportCurrentAndCS: true,
        canExportAll: false,
        canCheckOkCab: false,
        role: [
          Permissions.ROLE_ANETT,
        ],
      },
      children: [
        ExportRouting
      ]
    },
    {
      path: 'cab-db-integrity',
      component: StatisticComponent,
      data: {
        breadcrumb: 'Intégrité de la base CAB',
        stats: 'cab-db-integrity',
        searchByName: true,
        canExportCurrent: true,
        canExportCurrentAndCS: true,
        canExportAll: false,
        canCheckOkCab: true,
        loadButton: true
      },
      children: [
        ExportRouting
      ]
    },
    {
      path: 'conso-history',
      component: StatisticComponent,
      data: {
        breadcrumb: 'Historique des consommations',
        stats: 'conso-history',
        searchByName: false,
        canExportCurrent: true,
        canExportCurrentAndCS: true,
        canExportAll: false,
        canCheckOkCab: false,
        selectOptions: [
          { value: 'L', view: 'Liste des consommations' },
          { value: 'C', view: 'Par clients avec détail par produit et date' },
          { value: 'c', view: 'Par client avec cumul par produit' },
          { value: 'P', view: 'Par produits avec détail par client et date' },
          { value: 'p', view: 'Par produits avec cumul par client' }
        ],
        selectedValue: 'L',
        typesConso: [
          { value: 'C', view: 'Consommations' },
          { value: 'M', view: 'Mouvements' },
          { value: 'S', view: 'Sorties' },
        ],
        seletedTypeConso: 'C',
        rangePicker: true
      },
      children: [
        ExportRouting
      ]
    },
    {
      path: 'linge-hebergement',
      component: StatisticComponent,
      data: {
        breadcrumb: "Linge d'hébergemenent",
        stats: 'linge-hebergement',
        canExportCurrent: true,
      },
      children: [
        ExportRouting
      ]
    },
    StatsLHRouting
  ],
  data: {
    breadcrumb: 'Statistiques',
    'role': [
      'ROLE_STATISTIQUE',
    ],
  }
}
